<template>
  <div>
    <ysxkzTx />
  </div>
</template>

<script>
// 获取接口地址
import ysxkzTx from '@/components/tztx/ysxkzTx'
export default {
  name: 'Ysxkzwsytx',
  components: {
    ysxkzTx
    // sideMenu,
    // Header
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
